export { default } from './QRCode';
export type { QRCodeProps } from './QRCode';
